import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { JobLotReportDto } from '../../job-lot-report/dto/job-lot-report.dto';
import { JobLotPhaseReportDto } from '../../job-lot-phase-report/dto/job-lot-phase-report.dto';

/**
 * Response of the timeline write routes: the same two report rows the admin
 * used to fetch afterwards (GET job-lot-report/:id + GET job-lot-phase-report).
 */
export class JobPhaseTimelineResponseDto {
  @ApiProperty({ type: () => JobLotReportDto })
  @Expose()
  job!: JobLotReportDto;

  @ApiProperty({ type: () => [JobLotPhaseReportDto] })
  @Expose()
  jobPhases!: JobLotPhaseReportDto[];
}
